import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 85vh;

  .picker-body {
    overflow-y: auto;
    min-height: 320px;
    color: ${(props) => props.theme.$gray900};
  }

  .picker-footer {
    flex-shrink: 0;
  }
`;
